<template>
  <v-container fluid>
    <v-row justify="start">
      <v-col cols="12" lg="4" md="6" sm="12">
        <v-card>
          <v-card-title>
            Categorie incluse
          </v-card-title>
          <v-card-subtitle>
            Le categorie senza selezioni sono considerate totalmente incluse
          </v-card-subtitle>
          <v-card-text>
            <v-row justify="start" v-for="categoriaI in elencoCategorie" :key="categoriaI.codice">
              <v-col>
                <v-select v-model="categorieIncluse[categoriaI.codice]"
                  :items="itemsCategoria(categoriaI.codice)"
                  dense flat outlined
                  :label="categoriaI.descrizione"
                  multiple
                  chips
                  small-chips
                  hide-no-data
                  hide-details
                  item-text="descrizione"
                  item-value="codice"
                  clearable
                  :return-object="true"
                  @change="onChangeCategorie"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" lg="4" md="6" sm="12">
        <v-card>
          <v-card-title>
            Categorie escluse
          </v-card-title>
          <v-card-subtitle>
            Le categorie senza selezioni non sono considerate
          </v-card-subtitle>
          <v-card-text>
            <v-row justify="start" v-for="categoriaE in elencoCategorie" :key="categoriaE.codice">
              <v-col>
                <v-select v-model="categorieEscluse[categoriaE.codice]"
                  :items="itemsCategoria(categoriaE.codice)"
                  dense flat outlined
                  :label="categoriaE.descrizione"
                  multiple
                  chips
                  small-chips
                  hide-no-data
                  hide-details
                  item-text="descrizione"
                  item-value="codice"
                  clearable
                  :return-object="true"
                  @change="onChangeCategorie"
                ></v-select>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import _ from 'lodash'
  import configurazioni from '@/services/configurazioniService.js'

  export default {
    components: {
    },
    props: {
    },
    data: () => ({
      panel: 0,
      elencoCategorie: [],
      categorie: {},
      categorieIncluse: {},
      categorieEscluse: {},
      dItemsCategoria: {}
    }),
    async mounted() {
      const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      this.elencoCategorie = _.get(impostazioni, 'inventario.categorie', [{ "codice": "categoria1", "descrizione": "Categoria1", "source": "prodotti_categorie.categorie.categoria1" }])

      for (let categoria of this.elencoCategorie) {
        const items = await this.getItemsCategoria(categoria.codice)
        this.$set(this.dItemsCategoria, categoria.codice, items)
      }
    },
    computed: {

    },
    methods: {
      itemsCategoria(codice) {
        return codice && this.dItemsCategoria[codice] ? this.dItemsCategoria[codice] : []
      },
      async getItemsCategoria(codice) {
        var elementi
        const item = this.elencoCategorie.find(x => x.codice === codice)
        if (typeof item.source === 'string') {
          const config = item.source.split('.')
          const configId = config[0]
          const subId = config[1] || ''
          const sub2 = config[2] || ''
          this.sourceArray = await configurazioni.getConfigurazione(configId, subId)
          if (sub2) {
            elementi = this.sourceArray ? this.sourceArray.filter(x => x.tipo === sub2).map(x => { return { codice: x.codice, descrizione: x.descrizione.toUpperCase() } }) : []
          } else {
            // TODO: Correggere gestione Marchi generale. In questo caso devo modificare altrimenti non funziona il filtro
            // Quando a posto togliere caso particolare !!!!
            if (item.codice === 'marchio') {
              elementi = this.sourceArray ? this.sourceArray.map(x => { return { codice: x.descrizione, descrizione: x.descrizione.toUpperCase() } }) : []
            } else {
              elementi = this.sourceArray ? this.sourceArray.map(x => { return { codice: x.codice, descrizione: x.descrizione.toUpperCase() } }) : []
            }
          }
          elementi = _.sortBy(elementi, 'descrizione')
        } else if (Array.isArray(this.item.source)) {
          elementi = [...this.item.source]
        }
        elementi = elementi.map(x => { return { ...x, chiave: item.model }})
        return elementi
      },
      onChangeCategorie() {
        this.$emit('selezione', { incluse: this.categorieIncluse, escluse: this.categorieEscluse })
      }
    }
  }
</script>
